export const parseQueryString = (queryString: string): Record<string, string> =>
  queryString
    .substring(1)
    .split('&')
    .map((x) => x.split('='))
    .reduce((acc, cur) => ({ ...acc, [cur[0]]: cur[1] }), {});
